module.exports = "<div class=\"container\">\n  <h3>\n    Portfolio\n  </h3>\n  <p class=\"lead\">My portfolio is being built as you read this!</p>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/Gabe/Desktop/AngularApps/GabesWebsitePublic/GabesWebsite/src/app/portfolio/portfolio.component.html
// module id = ../../../../../src/app/portfolio/portfolio.component.html
// module chunks = main